<div class="container-div" @fadeInAnimation>
  <div class="title">
    {{ 'ADMIN.LOCAL_OFFICE.LABEL' | translate }}
  </div>
  <div class="list">
    <app-local-office-filter
      [localOffices]="sandbox.editableLocalOffices$ | async"
      [loading]="sandbox.loading$ | async"
      [busy]="sandbox.processing$ | async"
      (editLocalOffice)="editLocalOffice($event)"
      (clearSelection)="localOfficeToEdit = null"
    ></app-local-office-filter>
  </div>
  <div class="edit">
    <app-edit-local-office
      [localOffice]="localOfficeToEdit"
      [saving]="sandbox.saving$ | async"
      (cancelClicked)="localOfficeToEdit = null"
      (saveClicked)="save($event)"
      *ngIf="!!localOfficeToEdit"
      ></app-edit-local-office>
  </div>
</div>
